import ScrollService from './scroll-service';
import TooltipService from './tooltip-service';

const MODULE_NAME = 'app.common.services';
const module = angular.module(MODULE_NAME, [])
    .service('scrollService', ScrollService)
    .service('tooltipService', TooltipService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/services/services-module.js